import { render } from "./windSpeed.vue?vue&type=template&id=49dd312a&ts=true"
import script from "./windSpeed.vue?vue&type=script&lang=ts"
export * from "./windSpeed.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__